import TeamStatistics from 'components/general/TeamStatistics'

function WruTeamStats({ data }) {

  const stats = [
    { code: 'TRY'},
    { code: 'OF'},
    { code: 'DF' },
    { code: 'TO' },
    { code: 'ST' },
    { code: 'PTY' },
    { code: 'FF' },
    { code: 'DQF' },
  ]


  return (<>
    <TeamStatistics data={data?.results} stats={stats.reverse()} />
  </>);
}


export default WruTeamStats;